const fileEntities = (state) => state.files.entities;

export const getFileById = (state, fileId) => {
    return fileEntities(state)[fileId];
}

export const getStatusByFile = (state, fileId) => {
    return state.files.statusByFile[fileId];
}